import type { ChatRoomResponseBasicInfoAllOf } from './chatRoomResponseBasicInfoAllOf';
import type { ChatRoomResponseBasicInfoAllOfTwo } from './chatRoomResponseBasicInfoAllOfTwo';

export type ChatRoomResponseBasicInfo = ChatRoomResponseBasicInfoAllOf & ChatRoomResponseBasicInfoAllOfTwo;
